import http from "@/settings/apiSettings"

class ProduseDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/PRO_Produse", data);
    }
    getParents(): Promise<any> {
        return http.clientComercialOdata.get("/PRO_Clase/with-parent");
    }

}
export default new ProduseDataService();